import MentorStatusChip from 'components/Chips/MentorStatusChip';
import { PageHeadContainer } from 'components/PageHead';
import { FC } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import User from 'types/User';
import MentorChart from '../MentorChart';

export const PageTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  & h1 {
    font-weight: 500;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  & p {
    margin-top: 0.75rem;
    font-size: 1rem;
    color: var(--gray-500);
  }
`;

const Head: FC = () => {
  const { data: user } = useSWR<User>('/auth/profile');
  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Mentorat</h1>
        {user?.mentorStatus === 'SIGNING_CHART' && (
          <>
            <MentorStatusChip status="SIGNING_CHART" />
            <p>Veuillez lire et signer la charte de mentorat</p>
          </>
        )}
      </PageTitle>
    </PageHeadContainer>
  );
};

const SignChart: FC = () => {
  return (
    <div>
      <Head />
      <MentorChart />
    </div>
  );
};

export default SignChart;
